<template>
  <a href="#main" class="skip-link">Skip to content</a>
  <NavigationMenu />
  <main id="main">
    <slot />
  </main>
  <FooterComponent />
  <CookiesConsentPopup />
</template>

<script lang="ts" setup></script>
